// protomaps-leaflet déclare « declare const L: any » et n'importe pas Leaflet : il attend
// une globale window.L. Notre bundle importe Leaflet en module ESM, donc la globale
// n'existerait pas et leafletLayer() lèverait « L is not defined » à l'appel.
//
// Ce module la pose comme effet de bord, et il est importé avant protomaps-leaflet : ainsi
// la globale est en place même si la bibliothèque se met un jour à déréférencer L dès le
// chargement plutôt qu'à l'appel.
import L from 'leaflet';

if (typeof window !== 'undefined' && !window.L) window.L = L;

export default L;
